import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";

const FeeSale = () => {
  const [theme, switchTheme] = useTheme();

  const [showFee, setShowFee] = useState(false);

  const [vazn, setVazn] = useState("");

  const [ayar, setAyar] = useState("");

  const [goldPrice, setGoldPrice] = useState(0);

  const [res, setRes] = useState([false, ""]);

  useEffect(() => {
    const form = new FormData();
    form.append("get_cost_online", 1);
    const requ = new Request(
      "https://hamrahvitrin.ir/LiveGallery/dataProcess.php",
      {
        method: "POST",
        body: form,
      }
    );
    fetch(requ)
      .then((res) => res.json())
      .then((data) => {
        setGoldPrice(parseInt(data.result.geram18.ask));
      });
  }, []);

  const vaznHandle = (event) => {
    if (isNaN(event.target.value)) {
      return;
    }
    setVazn(event.target.value);
  };

  const ayarHandle = (event) => {
    if (isNaN(event.target.value)) {
      return;
    }
    setAyar(event.target.value);
  };

  const formatNumber = (num) => {
    return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
  };

  const compute = () => {
    if (isNaN(parseFloat(vazn)) || isNaN(parseFloat(ayar))) {
      setRes([false, "لطفا همه فیلد ها را پر کنید"]);
      return;
    }
    const price = formatNumber(
      parseInt(
        Math.round((parseFloat(vazn) * ayar * goldPrice) / 750 / 1000) * 1000
      )
    );
    setRes([true, "قیمت محصول مورد نظر شما تقریبا " + price + " ریال میباشد"]);
  };

  return (
    <>
      <Nav.Link
        onClick={() => {
          setShowFee(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        قیمت برای فروش
      </Nav.Link>

      <Modal
        show={showFee}
        onHide={() => setShowFee(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark rtl justify-content-center"
              : "rtl justify-content-center bg-dark text-light"
          }
        >
          قیمت برای فروش
        </Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="mt-3">
            <input
              className={"form-control rtl"}
              placeholder="وزن"
              type="text"
              inputMode="numeric"
              maxLength="5"
              value={vazn}
              onChange={vaznHandle}
            ></input>
          </div>
          <div className="mt-3">
            <input
              className={"form-control rtl"}
              placeholder="عیار"
              type="text"
              inputMode="numeric"
              maxLength="5"
              value={ayar}
              onChange={ayarHandle}
            ></input>
          </div>
          <div className="mt-3 text-center">
            <button
              className="btn btn-success "
              onClick={() => {
                compute();
              }}
            >
              محاسبه
            </button>
          </div>
          <h5
            className={
              res[0]
                ? "mt-3 text-center text-success"
                : "mt-3 text-center text-danger"
            }
          >
            {res[1]}
          </h5>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button className="btn btn-dark" onClick={() => setShowFee(false)}>
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default FeeSale;
